import { useMemo } from 'react';
import { Box } from '@mui/material';

import { SHRED_COLORS } from '../constants';

const COLORS = [SHRED_COLORS.ember, SHRED_COLORS.flame, SHRED_COLORS.gold, '#b57bff', '#fff3e8', '#8e44ff'];
const PIECES = 70;

// Deterministic spread so the burst looks random without Math.random in render.
const buildPieces = () =>
  Array.from({ length: PIECES }, (_, i) => ({
    left: `${(i * 53) % 100}%`,
    delay: `${((i * 37) % 60) / 100}s`,
    duration: `${2.4 + ((i * 17) % 18) / 10}s`,
    drift: `${((i * 29) % 160) - 80}px`,
    spin: `${360 + ((i * 41) % 720)}deg`,
    color: COLORS[i % COLORS.length],
    size: 6 + (i % 5) * 2,
    round: i % 3 === 0,
  }));

const Confetti = ({ onDone }) => {
  const pieces = useMemo(buildPieces, []);
  const lastIndex = useMemo(
    () =>
      pieces.reduce(
        (best, piece, i) => (parseFloat(piece.delay) + parseFloat(piece.duration) > parseFloat(pieces[best].delay) + parseFloat(pieces[best].duration) ? i : best),
        0
      ),
    [pieces]
  );
  return (
    <Box aria-hidden="true" sx={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 1300, overflow: 'hidden' }}>
      {pieces.map((piece, i) => (
        <Box
          key={i}
          onAnimationEnd={i === lastIndex ? onDone : undefined}
          sx={{
            position: 'absolute',
            top: -20,
            left: piece.left,
            width: piece.size,
            height: piece.round ? piece.size : piece.size * 1.6,
            borderRadius: piece.round ? '50%' : '2px',
            background: piece.color,
            '--drift': piece.drift,
            '--spin': piece.spin,
            animation: `shredConfetti ${piece.duration} cubic-bezier(0.3, 0.6, 0.4, 1) ${piece.delay} forwards`,
          }}
        />
      ))}
    </Box>
  );
};

export default Confetti;
